import { render, staticRenderFns } from "./YlmsItemTwo.vue?vue&type=template&id=fe7b9d8e&scoped=true&"
import script from "./YlmsItemTwo.vue?vue&type=script&lang=ts&"
export * from "./YlmsItemTwo.vue?vue&type=script&lang=ts&"
import style0 from "./YlmsItemTwo.vue?vue&type=style&index=0&id=fe7b9d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7b9d8e",
  null
  
)

export default component.exports